const MegaMenu = ({ children }) => {
  return (
    <nav
      className="navbar navbar-expand-lg navbar-dark bg-dark shadow-sm pt-0 pb-0"
      id="mega-menu"
    >
      <div className="container">
        <ul className="navbar-nav nav-categories w-100 align-items-center">
          {children}
        </ul>
      </div>
    </nav>
  );
};

export { MegaMenu };
